import { Component, inject, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { OptionButtonGroupComponent } from 'src/app/components/form/option-button-group/option-button-group.component';
import { SharedInputComponent } from 'src/app/components/form/shared-input/shared-input.component';
import { PaymentStore } from '../../store/payment-report.store';

import { AuthService } from '@auth0/auth0-angular';
import { VALIDATION_PATTERNS } from 'src/app/utils/validation-patterns.util';
import { devEnvironment } from 'src/environments/environment';

@Component({
  selector: 'app-identification-step',
  imports: [CommonModule, ReactiveFormsModule, SharedInputComponent, TranslateModule, OptionButtonGroupComponent],
  templateUrl: './identification-step.component.html',
})
export class IdentificationStepComponent implements OnDestroy {
  private fb = inject(FormBuilder);
  private paymentStore = inject(PaymentStore);

  private formSubscription: Subscription | undefined;
  private auth = inject(AuthService);
  protected devEnvironment = devEnvironment;

  identificationForm = this.fb.group({
    name: [this.paymentStore.paymentDetailsComputed().payerName, Validators.required],
    email: [
      this.paymentStore.paymentDetailsComputed().email,
      [Validators.required, Validators.email, Validators.pattern(VALIDATION_PATTERNS.EMAIL)],
    ],
    userType: ['individual', Validators.required],
  });

  public onNextInner() {
    const payerName = this.identificationForm.get('name')?.value || '';
    const email = this.identificationForm.get('email')?.value || '';
    this.paymentStore.updatePaymentDetails({ payerName: payerName, email: email });
  }

  async redirectToLogin() {
    const paymentRequest = this.paymentStore.paymentRequest?.();
    if (paymentRequest) {
      const url = '?paymentId=' + paymentRequest.bill.shortId;
      this.auth.loginWithRedirect({
        appState: {
          target: '/home' + url,
        },
      });
      return;
    }
    const receiverNick = await this.paymentStore.targetUser?.();
    localStorage.setItem('targetShortId', receiverNick?.shortId || '');

    this.auth.loginWithRedirect({
      appState: { target: '/home' },
    });
  }

  ngOnDestroy() {
    if (this.formSubscription) {
      this.formSubscription.unsubscribe();
    }
  }

  isValidStep(): boolean {
    return this.identificationForm.valid;
  }
}
